//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 17.10.2016.
 */

(function () {

    'use strict';

    const FileSizeUnit = {
        KB: 'kb',
        MB: 'mb',
        GB: 'gb',
        TB: 'tb'
    };

    angular.module('container.widgets')
        .constant('FileSizeUnit', FileSizeUnit)
        .directive('srsngFileSize', srsngFileSize);

    function srsngFileSize() {

        return {
            restrict: 'A',
            require: 'ngModel',
            link: link
        };

        function link(scope, element, attrs, ngModel) {

            ngModel.$parsers.push(size => {

                console.log(size, 'unit:', attrs.srsngFileSize, ngModel.$modelValue);

                return size * getCoeff();
            });

            ngModel.$formatters.push(size => {

                return size / getCoeff();
            });

            function getCoeff() {

                switch (attrs.srsngFileSize) {
                    case FileSizeUnit.KB: default: return 1024;
                    case FileSizeUnit.MB: return Math.pow(1024, 2);
                    case FileSizeUnit.GB: return Math.pow(1024, 3);
                    case FileSizeUnit.TB: return Math.pow(1024, 4);
                }
            }
        }
    }
})();